import ErrorPage from "@/pages/error";
import DefaultLayout from "@/layouts/default";
import AuthGuard from "@/middleware/auth_guard";
import { createBrowserRouter, Navigate } from "react-router-dom";

// Routes
import coachRoutes from "./coach_routes";
import clientRoutes from "./client_routes";
import { authRoutes } from "./auth_routes";
import { editRoutes } from "./edit_routes";
import { libraryRoutes } from "./library_routes";


const router = createBrowserRouter([
  {  
    element: <AuthGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <DefaultLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: "dashboard",
            element: <div>Dashboard</div>
          },
          coachRoutes,
          clientRoutes, 
          libraryRoutes
        ],
      },
      editRoutes,
    ]
  },
  authRoutes
]);

export default router;